export const X_PIXEL_ID = "qxjsj";
export const X_TRIAL_EVENT_ID = "tw-qxjsj-rbtgy";
export const X_PURCHASE_EVENT_ID = "tw-qxjsj-qxjsk";
